<template>
  <div>
    <el-card
      shadow="never"
      style="height: 600px;"
    >
      <el-row
        slot="header"
        type="flex"
        justify="space-between"
        align="middle"
      >
        <div>
          <h3>
            {{ title }} ({{ total }})
          </h3>
        </div>
      </el-row>
      <PieChart
        :height="height"
        :width="width"
        :series="series"
        :labels="labels"
      />
    </el-card>
  </div>
</template>

<script>
import PieChart from "../../../components/charts/Pie.vue"
export default {
  name: "DashboardPieChart",
  components: {
    PieChart
  },
  props: {
    title: String,
    data: Array,
    width: Number,
    height: Number,
  },
  computed: {
    series() {
      return this.data.map((d) => d.count);
    },
    labels() {
      return this.data.map((d) => d.name);
    },
    total() {
      return this.series.reduce((a, b) => a + b, 0)
    }
  }
};
</script>

<style lang="scss" scoped></style>
